<template>
   <v-layout align-start>
      <v-flex xs12>
         <v-snackbar
            v-model="snackbar"
            :color="snackColor"
            :right="true"
            :bottom="true"
            :timeout="4000"
         >
            {{ snackText }}
            <template #action="{ attrs }">
               <v-btn
                  color="white"
                  text
                  v-bind="attrs"
                  @click="snackbar = false"
               >
                  Cerrar
               </v-btn>
            </template>
         </v-snackbar>

         <!-- DIALOG CREAR / EDITAR BECA -->
         <v-dialog v-model="dialogBeca" persistent max-width="600px">
            <v-form ref="formBecas" v-model="validBeca" lazy-validation>
               <v-card>
                  <v-card-text class="text--primary" style="margin-top: -20px">
                     <v-container grid-list-md>
                        <v-layout wrap>
                           <v-flex xs12>
                              <span class="text-h5 font-weight-medium">{{
                                 formTitle
                              }}</span>
                           </v-flex>
                        </v-layout>
                        <v-layout wrap>
                           <v-flex xs12 sm6>
                              <v-text-field
                                 v-model="carnet"
                                 v-mask="'####-AA-###'"
                                 :rules="rulesCarnet"
                                 color="primary"
                                 label="Carnet"
                              ></v-text-field>
                           </v-flex>
                           <v-flex xs12 sm6>
                              <v-text-field
                                 v-model="ciclo"
                                 :rules="rulesCiclo"
                                 color="primary"
                                 label="Ciclo"
                              ></v-text-field>
                           </v-flex>
                           <v-flex xs12 sm6>
                              <v-text-field
                                 v-model="talonario"
                                 :rules="rulesTalonario"
                                 color="primary"
                                 label="talonario"
                              ></v-text-field>
                           </v-flex>
                           <v-flex xs6>
                              <v-select
                                 v-model="selectInstitucion"
                                 :items="cmbInstitucion"
                                 :rules="rulesInstitucion"
                                 color="primary"
                                 item-text="nombre"
                                 item-value="institucionPatrocinadoraId"
                                 label="Institución"
                                 no-data-text="Sin resultados"
                                 placeholder="Seleccionar..."
                              ></v-select>
                           </v-flex>
                        </v-layout>
                     </v-container>
                  </v-card-text>

                  <v-card-actions
                     style="
                        margin-top: -40px;
                        margin-right: 20px;
                        padding-bottom: 20px;
                     "
                  >
                     <v-spacer></v-spacer>
                     <v-btn color="primary" text @click.native="close"
                        >Cancelar</v-btn
                     >
                     <v-btn
                        color="primary white--text"
                        :disabled="!validBeca"
                        @click.native="save"
                        >Guardar</v-btn
                     >
                  </v-card-actions>
               </v-card>
            </v-form>
         </v-dialog>
         <v-dialog v-model="dialogEnviandoComp" persistent width="300">
            <v-card color="primary" dark class="pt-5 pb-2">
               <v-card-text style="color: white">
                  Enviando becarios externos
                  <v-progress-linear
                     indeterminate
                     color="white"
                     class="mb-0"
                  ></v-progress-linear>
               </v-card-text>
            </v-card>
         </v-dialog>

         <!-- DIALOG DESACTIVAR -->
         <v-dialog v-model="dialogDesactivar" persistent max-width="600px">
            <v-card>
               <v-card-text class="text--primary" style="margin-top: -20px">
                  <v-container grid-list-md>
                     <v-layout wrap>
                        <v-flex xs12>
                           <span class="text-h5 font-weight-medium">Desactivar becario externo</span>
                        </v-flex>
                        <v-flex xs12>
                           <span class="font-weight-regular" style="font-size: 20px">
                              ¿Está seguro que desea desactivar este becario?
                           </span>
                           <v-layout wrap style="margin-top: 10px">
                              <v-flex xs12>
                                 <v-card
                                    flat
                                    color="orange lighten-5"
                                    class="text-center elevation-1"
                                    style="border-radius: 10px; padding: 15px 25px;"
                                 >
                                    <span class="orange--text text--darken-3 text-h6">{{ carnet }}</span>
                                 </v-card>
                              </v-flex>
                           </v-layout>
                           <v-layout wrap style="margin-top: 10px">
                              <v-flex xs12>
                                 <v-card
                                    flat
                                    color="orange lighten-5"
                                    class="text-center elevation-1"
                                    style="border-radius: 10px; padding: 15px 25px;"
                                 >
                                    <span class="orange--text text--darken-3 text-h6">{{ ciclo }}</span>
                                 </v-card>
                              </v-flex>
                           </v-layout>
                        </v-flex>
                        <v-flex xs12 text-center>
                           <v-icon color="orange darken-3" size="70" class="mt-2 mb-2">fa-ban</v-icon>
                        </v-flex>
                     </v-layout>
                  </v-container>
               </v-card-text>
               <v-card-actions style="margin-top: -30px; padding-bottom: 20px">
                  <v-spacer></v-spacer>
                  <v-btn color="orange darken-3" dark outlined min-width="150" @click.native="desactivarBecario">Si</v-btn>
                  <v-btn color="primary" dark min-width="150" @click.native="close">No</v-btn>
                  <v-spacer></v-spacer>
               </v-card-actions>
            </v-card>
         </v-dialog>

         <!-- DIALOG ELIMINAR  -->
         <v-dialog v-model="dialogEliminar" persistent max-width="600px">
            <v-form ref="formEliminar">
               <v-card>
                  <v-card-text class="text--primary" style="margin-top: -20px">
                     <v-container grid-list-md>
                        <v-layout wrap>
                           <v-flex xs12>
                              <span class="text-h5 font-weight-medium"
                                 >Remover beca</span
                              >
                           </v-flex>
                           <v-flex xs12>
                              <span
                                 class="font-weight-regular"
                                 style="font-size: 20px"
                                 >¿Esta seguro que desea remover la beca?</span
                              >
                              <v-layout wrap style="margin-top: 10px">
                                 <v-flex xs12>
                                    <v-card
                                       flat
                                       color="red lighten-5"
                                       class="text-center elevation-1"
                                       style="
                                          border-radius: 10px;
                                          padding: 15px 25px;
                                       "
                                    >
                                       <span
                                          class="red--text text--darken-2 text-h6"
                                          >{{ carnet }}</span
                                       >
                                    </v-card>
                                 </v-flex>
                              </v-layout>
                              <v-layout wrap style="margin-top: 10px">
                                 <v-flex xs12>
                                    <v-card
                                       flat
                                       color="red lighten-5"
                                       class="text-center elevation-1"
                                       style="
                                          border-radius: 10px;
                                          padding: 15px 25px;
                                       "
                                    >
                                       <span
                                          class="red--text text--darken-2 text-h6"
                                          >{{ ciclo }}</span
                                       >
                                    </v-card>
                                 </v-flex>
                              </v-layout>
                           </v-flex>
                           <v-flex xs12 text-center>
                              <v-icon
                                 color="primary"
                                 size="70"
                                 class="mt-2 mb-2"
                                 >fa-trash-alt</v-icon
                              >
                           </v-flex>
                        </v-layout>
                     </v-container>
                  </v-card-text>

                  <v-card-actions
                     style="margin-top: -30px; padding-bottom: 20px"
                  >
                     <v-spacer></v-spacer>
                     <v-btn
                        color="primary"
                        dark
                        outlined
                        min-width="150"
                        @click.native="removerBecas"
                        >Si</v-btn
                     >
                     <v-btn
                        color="primary"
                        dark
                        min-width="150"
                        @click.native="close"
                        >No</v-btn
                     >
                     <v-spacer></v-spacer>
                  </v-card-actions>
               </v-card>
            </v-form>
         </v-dialog>

         <!-- DIALOG ADJUNTAR -->
         <v-dialog v-model="dialogAdjunto" persistent max-width="600px">
            <v-form ref="formAdjunto" v-model="validAdjunto" lazy-validation>
               <v-card>
                  <v-card-text class="text--primary" style="margin-top: -20px">
                     <v-container grid-list-md>
                        <v-layout wrap>
                           <v-flex xs12>
                              <span class="text-h5 font-weight-medium"
                                 >Adjuntar listado</span
                              >
                           </v-flex>
                        </v-layout>
                        <v-layout wrap>
                           <v-flex xs12>
                              <v-file-input
                                 v-model="archivosAdjuntos"
                                 color="primary"
                                 :rules="adjuntosRules"
                                 label="Archivo adjunto"
                                 placeholder="Selecciona tu archivo"
                                 prepend-icon="fa-paperclip"
                                 accept=".csv"
                                 outlined
                                 multiple
                                 counter
                                 :show-size="1000"
                              >
                                 <template #selection="{ text }">
                                    <v-chip color="primary" dark label small>
                                       {{ text }}
                                    </v-chip>
                                 </template>
                              </v-file-input>
                           </v-flex>
                        </v-layout>
                     </v-container>
                  </v-card-text>

                  <v-card-actions
                     style="
                        margin-top: -40px;
                        margin-right: 20px;
                        padding-bottom: 20px;
                     "
                  >
                     <v-spacer></v-spacer>
                     <v-btn color="primary" text @click.native="close"
                        >Cancelar</v-btn
                     >
                     <v-btn
                        color="primary white--text"
                        :disabled="!validAdjunto"
                        @click.native="saveAdjunto"
                        >Guardar</v-btn
                     >
                  </v-card-actions>
               </v-card>
            </v-form>
         </v-dialog>

         <!-- ================= MENÚ ================= -->
         <!-- Los apartados se muestran de a uno para que la pantalla no crezca
              demasiado; la lógica sigue en este componente y solo se alterna
              qué bloque se dibuja. -->
         <v-container v-if="!vista" fluid>
            <v-layout
               wrap
               :style="
                  $vuetify.breakpoint.xlOnly
                     ? 'padding-right: 10%; padding-left: 10%'
                     : ''
               "
            >
               <v-flex xs12 text-center mb-8>
                  <span class="font-weight-medium text-h5">
                     Becarios externos
                  </span>
                  <div class="caption grey--text text--darken-1 mt-2">
                     Seleccione el apartado que desea consultar.
                  </div>
               </v-flex>

               <v-flex xs12>
                  <v-container class="px-1" grid-list-md fluid>
                     <v-layout wrap justify-center>
                        <v-flex
                           v-for="opcion in opcionesMenu"
                           :key="opcion.vista"
                           xs12
                           sm6
                           md4
                        >
                           <v-layout align-center justify-center wrap>
                              <v-flex
                                 xs12
                                 :class="
                                    $vuetify.breakpoint.smAndUp ? 'px-8' : ''
                                 "
                              >
                                 <v-btn
                                    rounded
                                    color="primary"
                                    block
                                    height="60px"
                                    x-large
                                    @click="vista = opcion.vista"
                                 >
                                    <v-icon left>{{ opcion.icono }}</v-icon>
                                    {{ opcion.titulo }}
                                 </v-btn>
                              </v-flex>
                              <v-flex xs12 class="text-center mt-4 mb-8">
                                 <div class="body-2 grey--text text--darken-1">
                                    {{ opcion.descripcion }}
                                 </div>
                              </v-flex>
                           </v-layout>
                        </v-flex>
                     </v-layout>
                  </v-container>
               </v-flex>
            </v-layout>
         </v-container>

         <!-- VOLVER: solo dentro de un apartado -->
         <v-container v-if="vista" fluid class="pb-0">
            <v-btn text color="primary" @click="vista = null">
               <v-icon left small>fas fa-arrow-left</v-icon> Volver
            </v-btn>
         </v-container>

         <v-card v-if="vista === 'BECAS'" elevation="0">
            <v-toolbar color="primary" dark>
               <v-toolbar-title style="font-weight: 500"
                  >Becas externas</v-toolbar-title
               >
               <div class="mt-6 ml-3" style="width: 150px">
                  <v-autocomplete
                     v-model="selectCicloBecas"
                     :items="cmbCiclosBecas"
                     color="primary"
                     item-text="nombre"
                     item-value="nombre"
                     label="Ciclo"
                     no-data-text="Sin resultados"
                     placeholder="Seleccionar..."
                  >
                  </v-autocomplete>
               </div>
               <div class="mt-6 ml-3" style="width: 140px">
                  <v-select
                     v-model="selectActivoBecas"
                     :items="cmbActivoBecas"
                     color="primary"
                     item-text="label"
                     item-value="value"
                     label="Estado"
                     dense
                  />
               </div>
               <v-spacer></v-spacer>
               <v-text-field
                  ref="txtBusqueda"
                  v-model="search"
                  class="mt-3"
                  color="white"
                  append-icon="fa-search"
                  label="Búsqueda"
                  single-line
               ></v-text-field>
               <v-spacer></v-spacer>
               <v-tooltip bottom max-width="300" color="primary">
                  <template #activator="{ on }">
                     <v-btn
                        text
                        icon
                        color="white darken-3"
                        v-on="on"
                        @click="nuevaBeca()"
                     >
                        <v-icon>fas fa-plus</v-icon>
                     </v-btn>
                  </template>
                  <span style="font-size: 15px"> Nueva Beca </span>
               </v-tooltip>

               <!-- <v-tooltip bottom color="amber darken-3">
                  <template #activator="{ on }">
                     <v-btn
                        text
                        icon
                        color="amber lighten-2"
                        v-on="on"
                        @click="tourActivo = true"
                     >
                        <v-icon>fa-question-circle</v-icon>
                     </v-btn>
                  </template>
                  <span style="font-size: 15px"> Ayuda / Tutorial </span>
               </v-tooltip> -->
               <v-tooltip bottom color="primary">
                  <template #activator="{ on, attrs }">
                     <v-btn
                        text
                        icon
                        color="white darken-3"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialogAdjunto = true"
                     >
                        <v-icon>fas fa-book</v-icon>
                     </v-btn>
                  </template>
                  <span>Adjuntar CSV</span>
               </v-tooltip>
            </v-toolbar>

            <!-- DATATABLE becas -->
            <v-data-table
               :headers="headers"
               :items="filteredBecas"
               :loading="loadingBecas"
               loading-text="Listando becas, por favor espere..."
               no-data-text="No se encontraron becas para el ciclo seleccionado."
               :search="search"
               :footer-props="{
                  itemsPerPageOptions: [10, 25, 50],
                  itemsPerPageText: 'Filas por página:'
               }"
               no-results-text="Búsqueda sin resultados"
               class="elevation-1"
            >
               <template #footer="{}">
                  <tr>
                     <td :colspan="headers.length">
                        <v-layout align-center justify-start fill-height>
                           <div class="mx-4">
                              <span class="text-body-1 font-weight-medium">
                                 Buscar por
                              </span>
                           </div>
                           <div style="margin-top: 5px">
                              <v-radio-group v-model="radiosBusqueda" row>
                                 <v-radio
                                    label="Nombre"
                                    color="primary"
                                    value="r-nombre"
                                 ></v-radio>
                                 <v-radio
                                    label="Carnet"
                                    color="primary"
                                    value="r-carnet"
                                 ></v-radio>
                                 <v-radio
                                    label="Carrera"
                                    color="primary"
                                    value="r-carrera"
                                 ></v-radio>
                                 <v-radio
                                    label="Patrocinador"
                                    color="primary"
                                    value="r-patrocinador"
                                 ></v-radio>
                                 <v-radio
                                    label="Talonario"
                                    color="primary"
                                    value="r-talonario"
                                 ></v-radio>
                              </v-radio-group>
                           </div>
                        </v-layout>
                     </td>
                  </tr>
               </template>
               <template #item.activo="{ item }">
                  <v-chip small :color="item.activo ? 'success' : 'error'" dark>
                     {{ item.activo ? 'Activo' : 'Inactivo' }}
                  </v-chip>
               </template>

               <template #item.desactivadoPor="{ item }">
                  {{ item.desactivadoPor || '—' }}
               </template>

               <template #item.opciones="{ item }">
                  <v-tooltip bottom max-width="300" color="primary">
                     <template #activator="{ on }">
                        <v-btn
                           text
                           small
                           fab
                           color="amber darken-3"
                           v-on="on"
                           @click="editItem(item)"
                        >
                           <v-icon>fa-pen</v-icon>
                        </v-btn>
                     </template>
                     <span style="font-size: 15px"> Editar </span>
                  </v-tooltip>

                  <v-tooltip bottom max-width="300" color="orange darken-3" v-if="item.activo">
                     <template #activator="{ on }">
                        <v-btn
                           text
                           small
                           fab
                           color="orange darken-3"
                           v-on="on"
                           @click="desactivarItem(item)"
                        >
                           <v-icon>fa-ban</v-icon>
                        </v-btn>
                     </template>
                     <span style="font-size: 15px"> Desactivar </span>
                  </v-tooltip>

                  <v-tooltip bottom max-width="300" color="success" v-if="!item.activo">
                     <template #activator="{ on }">
                        <v-btn
                           text
                           small
                           fab
                           color="success"
                           v-on="on"
                           @click="reactivarBecario(item.becarioExternoId)"
                        >
                           <v-icon>fa-check-circle</v-icon>
                        </v-btn>
                     </template>
                     <span style="font-size: 15px"> Reactivar </span>
                  </v-tooltip>

                  <v-tooltip bottom max-width="300" color="primary">
                     <template #activator="{ on }">
                        <v-btn
                           text
                           small
                           fab
                           color="primary"
                           v-on="on"
                           @click="deleteItem(item)"
                        >
                           <v-icon>fa-trash-alt</v-icon>
                        </v-btn>
                     </template>
                     <span style="font-size: 15px"> Eliminar </span>
                  </v-tooltip>
               </template>

               <!-- Si no hay datos, mostrar boton para listar de nuevo -->
               <template slot="no-data">
                  <div v-if="becas.length == 0">
                     <v-container>
                        <v-layout wrap align-center>
                           <v-flex xs12 class="text-center">
                              <v-btn color="primary" @click="reset"
                                 >Resetear</v-btn
                              >
                           </v-flex>
                        </v-layout>
                     </v-container>
                  </div>
               </template>
            </v-data-table>
         </v-card>

         <!-- DASHBOARD -->
         <v-container v-if="vista === 'DASHBOARD'" fluid>
            <DashboardBecasExternas />
         </v-container>
      </v-flex>

      <!-- TOUR DE AYUDA -->
      <TourBecasExternas :activo="tourActivo" @cerrar="tourActivo = false" />
   </v-layout>
</template>

<script>
import axios from 'axios'
import { authComputed } from '../helpers'
import { mask } from 'vue-the-mask'
import DashboardBecasExternas from './ReportesBecasExternas/DahsboardBecasExternas.vue'
import TourBecasExternas from './ReportesBecasExternas/TourBecasExternas.vue'

export default {
   name: 'Becas',
   components: { DashboardBecasExternas, TourBecasExternas },
   directives: {
      mask
   },
   data: () => ({
      // Apartado abierto: null = menú; 'BECAS' | 'DASHBOARD'
      vista: null,
      // Apartados cuyos datos ya se pidieron, para no repetir la consulta al volver
      cargado: {},
      opcionesMenu: [
         {
            vista: 'BECAS',
            titulo: 'Becas externas',
            icono: 'fas fa-table',
            descripcion: 'Listado de becas externas del ciclo seleccionado.'
         },
         {
            vista: 'DASHBOARD',
            titulo: 'Dashboard',
            icono: 'fas fa-chart-pie',
            descripcion: 'Resumen y estadísticas de las becas externas.'
         }
      ],

      // Variables
      validAdjunto: true,
      radiosBusqueda: 'r-nombre',
      tourActivo: false,
      dialogBeca: false,
      dialogEnviandoComp: false,
      dialogEliminar: false,
      dialogDesactivar: false,
      editedIndex: -1,
      headers: [
         { text: 'Carnet', value: 'carnet', class: 'titulo' },
         { text: 'Nombre', value: 'nombre', class: 'titulo', width: '250' },
         { text: 'Carrera', value: 'carrera', class: 'titulo', width: '250' },
         { text: 'Ciclo', value: 'ciclo', class: 'titulo' },
         { text: 'Fecha Adjunto', value: 'fecha', class: 'titulo' },
         { text: 'Talonario', value: 'numeroTalonario', class: 'titulo' },
         {
            text: 'Institución',
            value: 'institucionPatrocinadora',
            class: 'titulo',
            width: '200'
         },
         { text: 'Estado', value: 'activo', class: 'titulo', sortable: false },
         { text: 'Fecha Retiro', value: 'fechaRetiro', class: 'titulo' },
         { text: 'Inactivado por', value: 'desactivadoPor', class: 'titulo', sortable: false },
         {
            text: 'Opciones',
            value: 'opciones',
            align: 'right',
            sortable: false,
            class: 'titulo'
         }
      ],

      // Filtro activo/inactivo
      selectActivoBecas: 'todos',
      cmbActivoBecas: [
         { label: 'Activos', value: 'activos' },
         { label: 'Inactivos', value: 'inactivos' },
         { label: 'Todos', value: 'todos' }
      ],

      // Variables de formularios
      search: '',
      pagination: {},
      result: [],
      becas: [],
      swGeneraVenta: false,
      dialogBecaComp: false,
      cmbCiclosBecas: [],
      selectCicloBecas: '',
      loadingBecas: false,
      dialogAdjunto: false,
      validBeca: true,
      snackbar: false,
      snackText: '',
      snackColor: 'primary',
      selectInstitucion: '',
      cmbInstitucion: [],
      archivosAdjuntos: [],

      // Propiedades bodega
      becarioExternoId: '',
      carnet: '',
      ciclo: '',
      periodosLectivos: [],
      selectTipo: '',
      cmbTipoBeca: [],
      talonario: '',
      apellidos: '',
      email: '',
      direccion: '',
      dui: '',
      nit: '',

      // Reglas de validacion de formularios
      rulesCarnet: [(v) => !!v || 'Ingrese una carnet'],
      rulesCiclo: [(v) => !!v || 'Ingrese una ciclo'],
      rulesInstitucion: [(v) => !!v || 'Ingrese una Institución'],
      rulesTalonario: [(v) => !!v || 'Ingrese una talonario'],
      adjuntosRules: [
         (files) => files.length > 0 || 'Seleccione un archivo.',
         (files) => files.length <= 1 || 'Solo se puede subir un archivo.',
         (files) =>
            !files ||
            !files.some((file) => file.type != 'text/csv') ||
            'Solo se permiten archivos csv',
         (files) =>
            !files ||
            !files.some((file) => file.size > 15000000) ||
            'Los archivos adjuntos no pueden pesar mas de 15MB!'
      ]
   }),
   computed: {
      ...authComputed,
      // Titulo de dialog
      formTitle() {
         return this.editedIndex === -1
            ? 'Nueva beca externa'
            : 'Editar beca externa'
      },
      filteredBecas() {
         let base = this.becas
         if (this.selectActivoBecas === 'activos') {
            base = base.filter(i => i.activo !== false)
         } else if (this.selectActivoBecas === 'inactivos') {
            base = base.filter(i => i.activo === false)
         }
         switch (this.radiosBusqueda) {
            case 'r-nombres':
               return base.filter((i) => {
                  return (
                     !this.search || new RegExp(this.search, 'i').test(i.nombre)
                  )
               })
            case 'r-carnet':
               return base.filter((i) => {
                  return (
                     !this.search || new RegExp(this.search, 'i').test(i.carnet)
                  )
               })
            case 'r-carrera':
               return base.filter((i) => {
                  return (
                     !this.search ||
                     new RegExp(this.search, 'i').test(i.carrera)
                  )
               })
            case 'r-patrocinador':
               return base.filter((i) => {
                  return (
                     !this.search ||
                     new RegExp(this.search, 'i').test(
                        i.institucionPatrocinadora
                     )
                  )
               })
            case 'r-talonario':
               return base.filter((i) => {
                  return (
                     !this.search ||
                     new RegExp(this.search, 'i').test(i.numeroTalonario)
                  )
               })
            default:
               return base
         }
      }
   },
   watch: {
      selectCicloBecas() {
         this.listarBecas()
      },
      /**
       * Carga diferida: los combos y el listado se piden la primera vez que se entra
       * al apartado de becas, no al abrir la pantalla. Así el menú aparece de
       * inmediato y no se consulta lo que quizá no se vaya a ver.
       * El Dashboard carga sus propios datos por su cuenta.
       */
      vista(val) {
         if (val === 'BECAS' && !this.cargado.BECAS) {
            this.$set(this.cargado, 'BECAS', true)
            this.listarComboBoxes()
         }
      }
   },
   created() {
      //Validando acceso al componente
      // No se carga nada acá: cada apartado pide sus datos al abrirse (ver watch).
      if (!this.permController(11, 'ver')) {
         this.$router.push({ name: 'inicio' })
      }
   },
   methods: {
      // Autoseleccionar la busqueda al cambiar filtro de busquedad
      focusBusqueda() {
         this.$refs.txtBusqueda.focus()
      },
      // Popular el datatable
      listarBecas() {
         this.becas = []
         this.loadingBecas = true
         // Obteniendo becas
         axios
            .get('api/BecarioExterno?Ciclo=' + this.selectCicloBecas)
            .then((response) => {
               this.becas = response.data.map((b) => ({
                  ...b,
                  carrera: b.carreraCodigo === '3803'
                     ? 'LICENCIATURA EN GASTRONOMIA Y HOSTELERIA'
                     : b.carrera
               }))
               this.loadingBecas = false
            })
            .catch((error) => {
               console.log(error)
               this.loadingBecas = false
            })
      },
      // Si no cargaron bien las becas en el datatable se puede resetear
      reset() {
         this.listarBecas()
      },

      // Cargando informacion del item a editar
      editItem(item) {
         // Obteniendo valores para bodega segun id
         axios
            .get('api/BecarioExterno/' + item.becarioExternoId)
            .then((response) => {
               this.result = response.data
               this.becarioExternoId = this.result.becarioExternoId
               this.carnet = this.result.carnet
               this.ciclo = this.result.ciclo
               this.selectInstitucion = this.result.institucionPatrocinadoraId
               this.talonario = this.result.numeroTalonario
            })
            .catch((error) => {
               console.log(error)
            })
         this.editedIndex = 1
         this.dialogBeca = true
         if (document.activeElement instanceof HTMLElement)
            document.activeElement.blur()
      },
      // Muestra el dialog para remover unabodega
      deleteItem(item) {
         this.dialogEliminar = true
         this.carnet = item.carnet
         this.ciclo = item.ciclo
         this.becarioExternoId = item.becarioExternoId

         if (document.activeElement instanceof HTMLElement)
            document.activeElement.blur()
      },

      desactivarItem(item) {
         this.becarioExternoId = item.becarioExternoId
         this.carnet = item.carnet
         this.ciclo = item.ciclo
         this.dialogDesactivar = true
         if (document.activeElement instanceof HTMLElement)
            document.activeElement.blur()
      },
      reactivarBecario(id) {
         axios
            .patch('api/BecarioExterno/' + id + '/reactivar')
            .then(() => {
               this.listarBecas()
               this.snackText = 'Becario reactivado exitosamente!'
               this.snackColor = 'snackSuccess'
               this.snackbar = true
            })
            .catch((error) => {
               console.log(error)
               this.snackText = 'Error al reactivar el becario.'
               this.snackColor = 'snackError'
               this.snackbar = true
            })
      },
      desactivarBecario() {
         const usuario = this.oidcUser ? this.oidcUser.name : 'Desconocido'
         axios
            .patch(`api/BecarioExterno/${this.becarioExternoId}/desactivar?usuario=${encodeURIComponent(usuario)}`)
            .then(() => {
               this.listarBecas()
               this.close()
               this.snackText = 'Becario desactivado exitosamente!'
               this.snackColor = 'snackSuccess'
               this.snackbar = true
            })
            .catch((error) => {
               console.log(error)
               this.snackText = 'Error al desactivar el becario.'
               this.snackColor = 'snackError'
               this.snackbar = true
            })
      },
      // Cerrar ventana de dialogo
      close() {
         this.dialogBeca = false
         this.dialogAdjunto = false
         this.dialogEliminar = false
         this.dialogDesactivar = false
         this.clear()
         setTimeout(() => {
            this.editedIndex = -1
         }, 300)
      },
      // Guardar/Actulizar bodega
      save() {
         if (this.$refs.formBecas.validate()) {
            if (this.editedIndex > -1) {
               // Codigo para actualizar/editar
               axios
                  .put('api/BecarioExterno/' + this.becarioExternoId, {
                     carnet: this.carnet,
                     numeroTalonario: this.talonario,
                     institucionPatrocinadoraId: this.selectInstitucion,
                     ciclo: this.ciclo
                  })
                  .then((error) => {
                     this.listarBecas()
                     this.close()
                     this.snackText = error.response.data.detail
                     this.snackColor = 'snackError'
                     this.snackbar = true
                  })
                  .catch((error) => {
                     console.log(error)
                  })
            } else {
               // Codigo para guardar
               axios
                  .post('api/BecarioExterno', {
                     carnet: this.carnet,
                     numeroTalonario: this.talonario,
                     institucionPatrocinadoraId: this.selectInstitucion,
                     ciclo: this.ciclo
                  })
                  .then(() => {
                     this.listarBecas()
                     this.close()
                     this.snackText = 'Beca agregada exitosamente!'
                     this.snackColor = 'snackSuccess'
                     this.snackbar = true
                  })
                  .catch((error) => {
                     console.log(error)
                  })
            }
         }
      },

      // Limpiar formularios y componentes
      clear() {
         try {
            this.$refs.formBecas.resetValidation()
         } catch (error) {
            //Do nothing
         }
         try {
            this.$refs.formAdjunto.resetValidation()
         } catch (error) {
            //Do nothing
         }
         this.result = ''
         this.carnet = ''
         this.ciclo = ''
         this.talonario = ''
         this.selectInstitucion = ''
         this.archivosAdjuntos = []
      },
      nuevaBeca() {
         this.dialogBeca = true
      },
      removerBecas() {
         // Enviando metodo delete
         axios
            .delete('api/BecarioExterno?id=' + this.becarioExternoId)
            .then(() => {
               this.listarBecas()
               this.close()
               this.snackText = 'Beca removida exitosamente!'
               this.snackColor = 'snackSuccess'
               this.snackbar = true
            })
            .catch((error) => {
               console.log(error)
            })
      },
      listarComboBoxes() {
         // Obteniendo sub categorias
         axios
            .get('api/InstitucionPatrocinadora')
            .then((response) => {
               this.cmbInstitucion = response.data
            })
            .catch((error) => {
               console.log(error)
            })
         axios
            .get('api/Ciclos')
            .then((response) => {
               this.cmbCiclosBecas = response.data
               this.selectCicloBecas = response.data[0].nombre
            })
            .catch((error) => {
               console.log(error)
            })
      },
      showDetalles(item) {
         this.carnet = item.carnet
         this.periodosLectivos = []
         this.periodosLectivos.push(item.ciclo)
         this.dialogBecaComp = true
      },
      saveAdjunto() {
         if (this.$refs.formAdjunto.validate()) {
            // Codigo para guardar
            this.dialogEnviandoComp = true
            let formData = new FormData()
            for (let file of this.archivosAdjuntos) {
               formData.append('files', file, file.name)
            }
            axios
               .post('api/BecarioExterno/migrar', formData)
               .then(() => {
                  this.close()
                  this.snackText = 'Becarios agregados exitosamente!'
                  this.snackColor = 'snackSuccess'
                  this.snackbar = true
                  this.dialogEnviandoComp = false
                  this.listarBecas()
               })
               .catch((error) => {
                  console.log(error)
                  this.snackText = error.response.data.detail
                  this.snackColor = 'snackError'
                  this.snackbar = true
                  this.close()
                  this.dialogEnviandoComp = false
               })
         }
      }
   }
}
</script>
